const goBack = ({ event }) => {
  window.history.back()
}

export default goBack
